var window = global;
global.Module = {};

require('./dds-lib');
const dds = require('./dds-module')(global.Module);

module.exports = dds;
